import { IGetStaticDataResponse } from "../types";
import { EBrandCode, ECommunityCode, ECountryCode, ESignupStep } from "features/common";

export const mockGetStaticDataResponse: IGetStaticDataResponse = {
  result: {
    communityAccountId: 1,
    defaultLanguage: {
      languageId: 1,
      languageCode: "en",
      systemLanguageName: "English"
    },
    languages: [
      {
        languageId: 1,
        languageCode: "en",
        systemLanguageName: "English"
      },
      {
        languageId: 2,
        languageCode: "fr",
        systemLanguageName: "French"
      },
      {
        languageId: 3,
        languageCode: "nl",
        systemLanguageName: "Dutch"
      }
    ],
    signUpSteps: [
      ESignupStep.UserDetails,
      ESignupStep.CompanyDetails,
      ESignupStep.ProductsDetails,
      ESignupStep.Checkout
    ],
    countryFilterOptions: [
      {
        countryCode: ECountryCode.BE,
        countryName: "Belgium"
      },
      {
        countryCode: ECountryCode.FR,
        countryName: "France"
      },
      {
        countryCode: ECountryCode.PT,
        countryName: "Portugal"
      },
      {
        countryCode: ECountryCode.ES,
        countryName: "Spain"
      },
      {
        countryCode: ECountryCode.GB,
        countryName: "United Kingdom"
      }
    ],
    feeBands: [
      {
        feeBandId: 1,
        turnoverFrom: 0.0,
        turnoverTo: 74999.0,
        currency: "GBP",
        description: "Fee Band Level 1"
      },
      {
        feeBandId: 2,
        turnoverFrom: 75000.0,
        turnoverTo: 99999.0,
        currency: "GBP",
        description: "Fee Band Level 2"
      },
      {
        feeBandId: 3,
        turnoverFrom: 100000.0,
        turnoverTo: 199999.0,
        currency: "GBP",
        description: "Fee Band Level 3"
      },
      {
        feeBandId: 4,
        turnoverFrom: 200000.0,
        turnoverTo: 349999.0,
        currency: "GBP",
        description: "Fee Band Level 4"
      },
      {
        feeBandId: 5,
        turnoverFrom: 350000.0,
        turnoverTo: 699999.0,
        currency: "GBP",
        description: "Fee Band Level 5"
      },
      {
        feeBandId: 6,
        turnoverFrom: 700000.0,
        turnoverTo: 999999.0,
        currency: "GBP",
        description: "Fee Band Level 6"
      },
      {
        feeBandId: 7,
        turnoverFrom: 1000000.0,
        turnoverTo: 1499999.0,
        currency: "GBP",
        description: "Fee Band Level 7"
      },
      {
        feeBandId: 8,
        turnoverFrom: 1500000.0,
        turnoverTo: 2499999.0,
        currency: "GBP",
        description: "Fee Band Level 8"
      },
      {
        feeBandId: 9,
        turnoverFrom: 2500000.0,
        turnoverTo: 3499999.0,
        currency: "GBP",
        description: "Fee Band Level 9"
      },
      {
        feeBandId: 10,
        turnoverFrom: 3500000.0,
        turnoverTo: 5999999.0,
        currency: "GBP",
        description: "Fee Band Level 10"
      },
      {
        feeBandId: 11,
        turnoverFrom: 6000000.0,
        turnoverTo: 9999999.0,
        currency: "GBP",
        description: "Fee Band Level 11"
      },
      {
        feeBandId: 12,
        turnoverFrom: 10000000.0,
        turnoverTo: 14999999.0,
        currency: "GBP",
        description: "Fee Band Level 12"
      },
      {
        feeBandId: 13,
        turnoverFrom: 15000000.0,
        turnoverTo: 24999999.0,
        currency: "GBP",
        description: "Fee Band Level 13"
      },
      {
        feeBandId: 14,
        turnoverFrom: 25000000.0,
        turnoverTo: 49999999.0,
        currency: "GBP",
        description: "Fee Band Level 14"
      },
      {
        feeBandId: 15,
        turnoverFrom: 50000000.0,
        turnoverTo: 1000000000000.0,
        currency: "GBP",
        description: "Fee Band Level 15"
      }
    ],
    paymentMethods: [0, 1],
    brands: [
      {
        code: EBrandCode.Constructionline,
        name: "Constructionline"
      },
      {
        code: EBrandCode.BuildersProfile,
        name: "Builder's Profile"
      },
      {
        code: EBrandCode.Facilitiesline,
        name: "Facilitiesline"
      }
    ],
    isTrialFlow: true,
    activeCommunities: [
      {
        communityAccountId: 1,
        code: ECommunityCode.UK
      },
      {
        communityAccountId: 10000000,
        code: ECommunityCode.FR
      }
    ],
    businessLines: [
      { businessLineCode: 3, businessLineLabel: "Autre Secteur" },
      { businessLineCode: 1, businessLineLabel: "BTP - Construction" },
      { businessLineCode: 6, businessLineLabel: "Nettoyage" },
      { businessLineCode: 5, businessLineLabel: "Sécurité Privée" },
      { businessLineCode: 4, businessLineLabel: "Transport" },
      { businessLineCode: 2, businessLineLabel: "Travail Temporaire" }
    ],
    vatCountries: [
      {
        countryName: "Austria",
        countryCode: "AT"
      },
      {
        countryName: "Belgium",
        countryCode: "BE"
      },
      {
        countryName: "Bulgaria",
        countryCode: "BG"
      },
      {
        countryName: "Croatia",
        countryCode: "HR"
      },
      {
        countryName: "Cyprus",
        countryCode: "CY"
      },
      {
        countryName: "Czech Republic",
        countryCode: "CZ"
      },
      {
        countryName: "Denmark",
        countryCode: "DK"
      },
      {
        countryName: "Estonia",
        countryCode: "EE"
      },
      {
        countryName: "Finland",
        countryCode: "FI"
      },
      {
        countryName: "France",
        countryCode: "FR"
      },
      {
        countryName: "Germany",
        countryCode: "DE"
      },
      {
        countryName: "Greece",
        countryCode: "EL"
      },
      {
        countryName: "Hungary",
        countryCode: "HU"
      },
      {
        countryName: "Ireland",
        countryCode: "IE"
      },
      {
        countryName: "Italy",
        countryCode: "IT"
      },
      {
        countryName: "Latvia",
        countryCode: "LV"
      },
      {
        countryName: "Lithuania",
        countryCode: "LT"
      },
      {
        countryName: "Luxembourg",
        countryCode: "LU"
      },
      {
        countryName: "Malta",
        countryCode: "MT"
      },
      {
        countryName: "Netherlands",
        countryCode: "NL"
      },
      {
        countryName: "Poland",
        countryCode: "PL"
      },
      {
        countryName: "Portugal",
        countryCode: "PT"
      },
      {
        countryName: "Romania",
        countryCode: "RO"
      },
      {
        countryName: "Slovakia",
        countryCode: "SK"
      },
      {
        countryName: "Slovenia",
        countryCode: "SI"
      },
      {
        countryName: "Spain",
        countryCode: "ES"
      },
      {
        countryName: "Sweden",
        countryCode: "SE"
      }
    ]
  },
  isSuccess: true,
  message: null,
  validationIssues: null
};
